// extracted by mini-css-extract-plugin
export default {"cta":"JI-z","disabled":"KI-z"};